import { native } from '@forest/native-services'
import { appVersion, platform } from '~/params'

export function logNonFatalError(payload: {
  name: string
  code: number
  params?: Record<string, string>
}) {
  try {
    native.general.logNonFatalError({
      name: payload.name,
      code: payload.code,
      params: {
        ...payload.params,
        platform,
        app_version: appVersion,
        origin: location.origin,
      },
    })
  } catch (err) {
    console.error(err)
  }
}
